module.exports = __webpack_public_path__ + "img/yuki-image-box.d9ced566.jpg";